import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext';
import './PolicyPages.css';

const TermsOfService = () => {
  const { t } = useTranslation();

  return (
    <div className="policy-page">
      <div className="policy-container">
        <div className="policy-header">
          <h1>{t('termsOfService')}</h1>
          <p className="last-updated">
            {t('lastUpdated')}: {new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }).format(new Date())}
          </p>
        </div>

        <div className="policy-content">
          <section className="policy-section">
            <h2>{t('termsAgreement')}</h2>
            <p>{t('termsAgreementText')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('definitions')}</h2>
            <ul>
              <li><strong>{t('platform')}:</strong> {t('platformDefinition')}</li>
              <li><strong>{t('services')}:</strong> {t('servicesDefinition')}</li>
              <li><strong>{t('user')}:</strong> {t('userDefinition')}</li>
              <li><strong>{t('employer')}:</strong> {t('employerDefinition')}</li>
              <li><strong>{t('employee')}:</strong> {t('employeeDefinition')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('accountRegistration')}</h2>
            <p>{t('accountRegistrationText')}</p>
            <ul>
              <li>{t('accountAgeRequirement')}</li>
              <li>{t('accountAccurateInfo')}</li>
              <li>{t('accountSecurity')}</li>
              <li>{t('accountTransfer')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('servicesDescription')}</h2>
            <h3>{t('employmentServices')}</h3>
            <ul>
              <li>{t('employmentMatch')}</li>
              <li>{t('employmentVerification')}</li>
              <li>{t('employmentTraining')}</li>
              <li>{t('employmentSupport')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('userObligations')}</h2>
            <h3>{t('generalUserObligations')}</h3>
            <ul>
              <li>{t('obeyLaws')}</li>
              <li>{t('respectOthers')}</li>
              <li>{t('noFraud')}</li>
              <li>{t('accurateInfo')}</li>
              <li>{t('noHarassment')}</li>
            </ul>

            <h3>{t('employerObligations')}</h3>
            <ul>
              <li>{t('fairTreatment')}</li>
              <li>{t('timelyPayment')}</li>
              <li>{t('safeEnvironment')}</li>
              <li>{t('complianceLaws')}</li>
            </ul>

            <h3>{t('employeeObligations')}</h3>
            <ul>
              <li>{t('professionalConduct')}</li>
              <li>{t('honestSkills')}</li>
              <li>{t('commitment')}</li>
              <li>{t('respectEmployer')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('intellectualProperty')}</h2>
            <p>{t('ipOwnership')}</p>
            <p>{t('ipLicense')}</p>
            <p>{t('userContentLicense')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('limitationLiability')}</h2>
            <p>{t('liabilityDisclaimer')}</p>
            <p>{t('liabilityLimit')}</p>
            <p>{t('liabilityForceMajeure')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('termination')}</h2>
            <p>{t('terminationClause')}</p>
            <ul>
              <li>{t('terminationBreach')}</li>
              <li>{t('terminationInactivity')}</li>
              <li>{t('terminationRequest')}</li>
              <li>{t('terminationPlatform')}</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>{t('disputeResolution')}</h2>
            <p>{t('governingLaw')}</p>
            <p>{t('disputeProcess')}</p>
            <p>{t('mediationClause')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('changesToTerms')}</h2>
            <p>{t('termsChangesText')}</p>
          </section>

          <section className="policy-section">
            <h2>{t('contactUsTerms')}</h2>
            <p>{t('contactTermsText')}</p>
            <div className="contact-info">
              <p><strong>{t('email')}:</strong> info@urugowoc.com</p>
              <p><strong>{t('phone')}:</strong> +250 788350577</p>
              <p><strong>{t('address')}:</strong> Kayonza, Rwanda</p>
            </div>
          </section>
        </div>

        <div className="policy-footer">
          <Link to="/" className="back-home">{t('backToHome')}</Link>
          <Link to="/privacy" className="policy-link">{t('viewPrivacy')}</Link>
          <Link to="/sitemap" className="policy-link">{t('viewSitemap')}</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;